import React from "react";

import { withAuth } from "../../shared/containers/containerAuth";

import ValidateErrorMessage from "../../shared/items/static/validateErrorMessage";

import styles from "./registrationValidateResuld.module.scss";
import { withRegistration } from "../../shared/containers/containerRegistration";

const RegistrationValidateResuld = (props) => {
  const { registration } = props;

  return !!registration.errorsModel ? (
    <div className={styles.container_validateModel}>
      <ValidateErrorMessage title={registration.errorsModel} />
    </div>
  ) : null;
};

export default withRegistration(React.memo(RegistrationValidateResuld));
